<!--

Changes done by 
-> Mangesh SuryaWanshi
-> Ajay Vijay Malekar

-->
<!--Top Section-->

    <div class="row">
        <div class="col-md-12">
            <h1 id="headings" class="main-headings">Cisco Vulnerability Database (VDB) Release Notes {{releaseNoFromArray}}</h1>
            <p></p>
        </div>
    </div>

    <!--Auto Complete Suggestion-->
    <div class="row searchbox">
     <div class="col-md-12">
    <div class="search">
            
            <span class="search__icon icon-search"></span>
            <!-- style="width: 500px;" -->
            <span class="search__icon icon-close" (click)="clearSearch()"></span>
            <input type="text" class="input" name="name"  placeholder="Search" [(ngModel)]="releaseNo"
            (keydown.enter)="searchVDB()" (focusout)="searchVDB()" autocapitalize="none" >
            <div *ngIf="releaseNumberFound" class="icon icon-link icon-information tooltip tooltip--top" style="margin-left: 7px; bottom: 2px;opacity: 1;" (click)="copyToClipboard()">
                <div id="linkClicked" [ngClass]="getLinkcopiedCss()" >{{linkedHoverCopiedText}}</div>
            </div>
            
 
           <!--  <div class="select" style="width: 500px; max-width: 500px; ">
                <ul class="select__menu-items select__menu-items--opened">
                    <li class="select__menu-item" role="option">
                        Type a VDB release between {{relNumber[0].releaseNumber}}-{{relNumber[relNumber.length-1].releaseNumber}} and click Fetch Data
                    </li>
                    <li class="select__menu-item" role="option" aria-disabled="false" *ngIf="releaseNo !='' " (click)="getData()">
                        Show VDB Release notes for
                        <div class="tag" >
                            <span class="tag__title" >{{releaseNo}}</span>
                            <span class="tag__icon icon-close" (click)="clearSearch()"></span>
                        </div>
                    </li>

                </ul>
            </div> -->
            
            <div class="help-block">
                <span class="help-block__text" style="color :#7f7f86;">(Type a VDB release between {{releaseNoStart}} - {{releaseNoEnd}})</span>
            </div>

    </div>
    </div>
    </div>   
   
    <!-- release notes -->
   
    <div class="row">
        <div class="col-md-12 " id="releNoteData" 
        [innerHTML]="html">
        </div>
        <!-- <ng-template #sider=dynamicdirective dynamic></ng-template> -->
    </div>

    <footer class="footer" style="padding-right: 16px; margin-top: 20px;">
        <div class="footer__legal">
            2022 Cisco Systems, Inc. Cisco, Cisco Systems and Cisco Systems logo are registered trademarks of Cisco Systems, Inc. and/or its affiliates in the U.S. and certain other countries.
        </div>
    </footer>
    
   